<script setup lang="ts">
import EditMenuDrawer from '@/pages/erp/ds/menu/view/ds-menu-drawer.vue'
import type { MenuProperties } from '@/pages/erp/ds/menu/db/ds-menu-types'
import Swal from 'sweetalert2'
definePage({
    meta: {
        action: 'manage',
        subject: 'DSMENU',
    },
})

const compId = ref(useStorage('compNo').value)
const menuId = ref()
const menuType = ref()
const menuDesc = ref()

// Data table options
const currentPage = ref(1)
const size = ref(10)
const sortOrder = ref()
const orderByCol = ref()

// Update data table options
const updateOptions = (options: any) => {
  sortOrder.value = options.sortBy[0]?.key
  orderByCol.value = options.sortBy[0]?.order
}

// Headers

const grid1Headers = [
    { title: '資訊代碼', key: 'menuId' },
    { title: '描述', key: 'menuDesc' },
    { title: '授權群組', key: 'authorityGroup' },
    { title: '說明', key: 'groupDesc' },
    { title: '連結路徑', key: 'path' },
    { title: '操作', key: 'actions', sortable: false}
]


// champ 後端分頁是從 0 開始
const page = computed((): number => currentPage.value - 1)

// 👉 Fetching users
const { data: menusData, execute: fetchMenus } = await useApi<any>(createUrl('/ds/menu/menu/searchMenu', {
  query: {
    compId,
    menuId,
    menuType,
    menuDesc,
    page,
    size,
    orderByCol,
    sortOrder,
  },
}))

const datas = computed((): MenuProperties[] => menusData.value.data.menuPage.content)
const totalDatas = computed(() => menusData.value.data.menuPage.totalElements)

console.log('datas: ', datas)

const isEditDataDrawerVisible = ref(false)
const isNewData = ref(false)
const isCopyData = ref(false)

let voData = {}


const createData = () => {
  isEditDataDrawerVisible.value = true
  isNewData.value = true
  isCopyData.value = false
}

const editData = (menuData: MenuProperties) => {
  voData = menuData
  console.log('editMenu: ', voData)
  isEditDataDrawerVisible.value = true
  isNewData.value = false
  isCopyData.value = false
}

const copyData = (menuData: MenuProperties) => {
    voData = menuData
    console.log('copyMenu: ', voData)
    isEditDataDrawerVisible.value = true
    isNewData.value = true
    isCopyData.value = true
}

// 👉 Add new data
const addNewData = async (menuData: MenuProperties) => {
  await $api('/ds/menu/menu/createMenu', {
    method: 'POST',
    body: { menu: menuData },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '新增成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  // refetch data
  fetchMenus()
}

const updateData = async (menuData: MenuProperties) => {
  await $api('/ds/menu/menu/updateMenu', {
    method: 'PUT',
    body: { menu: menuData },
  }).then(() => {
      $swal({
      position: 'top-end',
      icon: 'success',
      title: '修改成功',
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    })
  })

  // refetch data
  fetchMenus()
}

  // 👉 Delete data
const deleteData = async (menuData: MenuProperties) => {
  const { menuId } = menuData
    $swal({
    title: `確定要刪除 ${menuData.menuId} 資料?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "確定",
    cancelButtonText: "取消",
    reverseButtons: true
  }).then((result) => {
    if (result.isConfirmed) {
        $api(`/ds/menu/menu/deleteMenu`, {
        method: 'DELETE',
        query: {
          menuId
        }
      }).then(() => {
          $swal({
          position: 'top-end',
          title: "刪除成功",
          timer: 1500,
          icon: "success"
        });

        // refetch Data
        fetchMenus()
      })
    }
  });

}

const clickRow = (event, select) => {
  console.log('clickRow: ', event, select)
  editData(select.item)
}

</script>

<template>
  <!-- 👉 Widgets -->

  <VCard class="mb-6">
    <VCardItem class="pb-2 pt-2">
      <VCardTitle>搜尋</VCardTitle>
    </VCardItem>

    <VCardText>
      <VRow>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="compId"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入公司ID"
          />
        </VCol>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="menuId"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入資訊代碼"
          />
        </VCol>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="menuType"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入資訊類別"
          />
        </VCol>
        <VCol
         cols="12"
         sm="2"
        >
          <AppTextField
            v-model="menuDesc"
            clearable
            clear-icon="mdi-close-circle"
            placeholder="請輸入描述"
          />
        </VCol>
      </VRow>
    </VCardText>

    <VDivider />

    <VCardText class="d-flex flex-wrap gap-4">
      <VSpacer />

      <div class="app-user-search-filter d-flex align-center flex-wrap gap-4">
        <!-- 👉 Add button -->
        <VBtn
                prepend-icon="tabler-plus"
                @click="createData"
        >
          新增菜單管理作業
        </VBtn>
      </div>
    </VCardText>

    <VDivider />

    <!-- SECTION datatable -->
    <VDataTableServer
            v-model:items-per-page="size"
            v-model:page="currentPage"
            :items="datas"
            :items-length="totalDatas"
            :headers="grid1Headers"
            class="text-no-wrap"
            @update:options="updateOptions"
    >

      <template #item.menuId="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.menuId }}
          </div>
      </template>

      <template #item.menuDesc="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.menuDesc }}
          </div>
      </template>

      <template #item.authorityGroup="{ item }">
          <div class="text-body-1 text-high-emphasis text-capitalize">
              <div class="font-weight-medium ">
                  {{ toCode(item.authorityGroup) }}
              </div>
              <div class="text-sm">
                  {{ toText(item.authorityGroup) }}
              </div>
          </div>
      </template>

      <template #item.groupDesc="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.groupDesc }}
          </div>
      </template>

      <template #item.path="{ item }">
          <div class="text-body-1 text-high-emphasis">
              {{ item.path }}
          </div>
      </template>

      <!-- Actions -->
      <template #item.actions="{ item }">
          <IconBtn @click="editData(item)">
              <VIcon icon="tabler-edit" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >編輯</v-tooltip>
          </IconBtn>
          <IconBtn @click="copyData(item)">
              <VIcon icon="tabler-copy" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >複製</v-tooltip>
          </IconBtn>
          <IconBtn @click="deleteData(item)">
              <VIcon icon="tabler-trash" />
              <v-tooltip
                      activator="parent"
                      location="bottom"
              >刪除</v-tooltip>
          </IconBtn>
      </template>

      <!-- pagination -->
      <template #bottom>
        <TablePagination
                v-model:page="currentPage"
                v-model:size="size"
                :items-per-page="size"
                :total-items="totalDatas"
        />
      </template>
    </VDataTableServer>
    <!-- SECTION -->
  </VCard>
  <!-- 👉 Edit -->
  <EditMenuDrawer
          v-model:isDrawerOpen="isEditDataDrawerVisible"
          :menu-data="voData"
          :is-new="isNewData"
          :is-copy="isCopyData"
          @create-data="addNewData"
          @update-data="updateData"
  />

</template>
